import React, { useState } from "react"
import EmbedContainer from "../../components/EmbedContainer"
import TrendingTopics from "./TrendingTopicsWidget.view"
import { useData } from "./TrendingTopicsWidget.data"

const WIDTH = 600
const HEIGHT = 500

const TrendingTopicsWidget = () => {
  const [activeView, setActiveView] = useState("ratio")

  const [data, maxData, , sort, sortActions] = useData(activeView)

  const actions = {
    ...sortActions,
    setActiveView,
  }

  return (
    <EmbedContainer
      id="trending"
      title="Trending Topics"
      description="The top themes related to Donald Trump and Joe Biden."
      width={WIDTH}
      height={HEIGHT}
      showGetUpdates
      showShareMenu
    >
      <TrendingTopics
        data={data}
        maxData={maxData}
        actions={actions}
        activeView={activeView}
        sort={sort}
      />
    </EmbedContainer>
  )
}

export default TrendingTopicsWidget
